// extracted by mini-css-extract-plugin
export default {"wrapper":"jr-z","viewport":"kr-z","container":"lr-z","slide":"mr-z"};